import React from 'react'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import { MyContext } from '../../ContextFile'
import {useListView} from '../../core/ListViewProvider'
import {CategoryListFilter} from './CategoryListFilter'

const CategoryListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const { state, setState } = React.useContext(MyContext);
  const openAddUserModal = () => {
    setState({name:'',primaryId:'',editclicked:false})
  }

  return (
    <button type='button' className='btn text-white '
    style={{background: '#9E2A8D'}} onClick={openAddUserModal}>
    <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2 text-white' />
    Add New
  </button>
  )
}

export {CategoryListToolbar}
